import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ClienteConsulta } from 'src/app/interfaces/clienteConsulta';
import { SrService } from 'src/app/service/sr.service';
import { SrFormComponent } from '../sr-form/sr-form.component';
import { ActivatedRoute, Params } from '@angular/router';
import { PdfsService } from 'src/app/service/pdfs.service';
import { SrDetalle } from 'src/app/interfaces/srDetalle';
import { Sr } from 'src/app/interfaces/sr';
import { LogonComponent } from '../logon/logon.component';

@Component({
  selector: 'app-consulta-cliente',
  templateUrl: './consulta-cliente.component.html',
  styleUrls: ['./consulta-cliente.component.css']
})
export class ConsultaClienteComponent implements OnInit {
  filtro={
    id_sr:0,
    id_et:0
  }
  sr:Sr;
  srD:SrDetalle;
  listSrD:SrDetalle[]=new Array ;
  estados?:ClienteConsulta[]=new Array<ClienteConsulta>();;

  constructor(private srService:SrService, private dialog: MatDialog, private rutaActiva: ActivatedRoute, private pdfObj: PdfsService) {
    this.sr={
      id:0,
      dni:0,
      origen_nombre:"",
      email:"",
      telefono:0,
      origen_provincia:"",
      origen_localidad:"",
      origen_direccion:"",
      origen_altura:0,
      origen_cp:"",
      origen_piso_departamento:"",
      id_franja_horaria:1,
      destino_cuit:0,
      destino_nombre:"",
      destino_telefono:0,
      destino_provincia:"",
      destino_localidad:"",
      destino_direccion:"",
      destino_entrecalles:"",
      destino_altura:0,
      destino_cp:"",
      destino_email:"",
      destino_piso_departamento:"",
      is_contrareembolso:false,
      contrareembolso_valor:0,
      contrareembolso_pago:false
    };
    this.srD={
      id_sr: 0,
      id_bulto:0,
      observacion:'',
      valor_declarado:0,
      peso:0,
      estado:1
    };

    this.filtro.id_sr=this.rutaActiva.snapshot.params.idsr;
    this.filtro.id_et=this.rutaActiva.snapshot.params.idet;
    if(this.filtro.id_sr===undefined)
    {
      this.filtro.id_sr=0;
      this.filtro.id_et=0;
    }
    this.buscar();

   }

  ngOnInit(): void {
  }

  imprimirEtiquetas(){
    this.pdfObj.makeEtiquetaBulto(this.sr,this.listSrD);
  }

  buscar(){
    if(this.filtro.id_sr>0){
      this.srService.consultaClienteSr(this.filtro.id_sr).subscribe((data:any) =>{
        this.estados=data;

        // console.log(this.estados)
      });

        this.srService.getById(this.filtro.id_sr).subscribe((element:Sr) =>{
          if(element.origen_piso_departamento===null){
            element.origen_piso_departamento="";
          }
        this.sr=element;
        // console.log(element);
        this.srService.getDetalle(this.filtro.id_sr).subscribe((detalle:any)=>{
        this.listSrD=detalle;
        });
        });


    }
    else
    {if(this.filtro.id_et>0)
      this.srService.consultaClienteEt(this.filtro.id_et).subscribe((data:any) =>{
        this.estados=data;
      });
    }

  }
  nuevaSr(){
    let dialogRef = this.dialog.open(SrFormComponent, {
      data: {id: 0},
      maxHeight: '90vh'
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', result);
      // this.srService.getPendientes().subscribe((data:any[]) =>{
      //   return data;
      //   // this.sr=data;

      // });

    });

  }



}
